import { createContext, useContext } from 'react';

export interface AuthContextInterface {
  isLoggingOut: boolean;
  logOut: () => Promise<void>;
}

export const authContext = createContext<AuthContextInterface | null>(null);

export const useAuthContext = () => {
  const context = useContext(authContext);
  if (context) {
    return context;
  }
  throw new Error('useAuthContext must be used within a provider');
};
